import { render, staticRenderFns } from "./AuditDialog.vue?vue&type=template&id=6bdce25a&scoped=true&"
import script from "./AuditDialog.vue?vue&type=script&lang=js&"
export * from "./AuditDialog.vue?vue&type=script&lang=js&"
import style0 from "./AuditDialog.vue?vue&type=style&index=0&id=6bdce25a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bdce25a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wp/Desktop/chuanti-pc/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6bdce25a')) {
      api.createRecord('6bdce25a', component.options)
    } else {
      api.reload('6bdce25a', component.options)
    }
    module.hot.accept("./AuditDialog.vue?vue&type=template&id=6bdce25a&scoped=true&", function () {
      api.rerender('6bdce25a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/competition/components/AuditDialog.vue"
export default component.exports